<nz-card class="dispatch-card card black-100" [nzTitle]="cardHeader" [nzBordered]="isBordered">
  <div class="card-body regular-14">
    <div *ngFor="let content of cardContent" class="row d-flex">
      <div class="row-label grey-60 pr-10 capitalize">{{content.label}}</div>
      <div class="row-value black-100" [ngSwitch]="content.type">
        <div *ngSwitchCase="detailCardContentType.TEXT" class="overflow-container" [attr.title]="content.text">
          {{content.text}}
        </div>
        <div *ngSwitchCase="detailCardContentType.CURRENCY">
          {{content.text | currency: content.currencyType}}
        </div>
        <div *ngSwitchCase="detailCardContentType.PHONE_NUMBER">
          <a class="blue-50" [href]="'tel:' + content.text">{{content.text}}</a>
        </div>
        <div *ngSwitchCase="detailCardContentType.EMAIL">
          <a class="blue-50" [href]="'mailto:' + content.text">{{content.text}}</a>
        </div>
        <div *ngSwitchCase="detailCardContentType.ADDRESS" class="overflow-container" [attr.title]="getFormattedAddress(content.address)">
          <div>{{getFormattedAddress(content.address)}}</div>
        </div>
        <div *ngSwitchCase="detailCardContentType.ATTACHMENTS">
          <div *ngFor="let attachment of content.attachments; let first = first" [class.mt-10]="!first">
            <div>{{attachment.heading}}</div>
            <a class="blue-50" (click)="attachmentClick(attachment.id)">{{attachment.name}}</a>
          </div>
        </div>
        <div *ngSwitchCase="detailCardContentType.BULLET_TEXTS">
          <div *ngFor="let textList of content.bulletList; let first = first" [class.mt-10]="!first">
            <span *ngFor="let text of textList; let last = last">
              {{text}}
              <span *ngIf="text && !last" class="bullet">&#183;</span>
            </span>
          </div>
        </div>
        <div *ngSwitchCase="detailCardContentType.TIME_WINDOW">
          <span *ngIf="content.timeWindow?.startDatetime || content.timeWindow?.endDatetime">
            {{getFormattedTimeWindow(content.timeWindow.startDatetime, content.timeWindow.endDatetime, userTimeZone)}} {{userTimezoneAbbr}}
          </span>
        </div>
        <div *ngSwitchDefault>{{content.text}}</div>
      </div>
    </div>
  </div>
</nz-card>
